<template>
  <div class="login-container">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center m-b-md">
          <h3>PASSWORD RECOVER</h3>
          <small>Please fill the form to recover your password</small>
        </div>
        <div class="hpanel">
          <div class="panel-body">
              <p>
                Enter your email address and your password will be reset and emailed to you.
              </p>
              <form v-on:submit="forgotPassword" action="#" method="post" id="recoverPassword">
                <div class="form-group">
                  <label class="control-label" for="email">Email</label>
                  <input type="email" placeholder="example@gmail.com" title="Please enter you email adress" required="" v-model="email" value="" name="email" id="email" class="form-control">
                  <span class="help-block small">Your registered email address</span>
                </div>

                <div v-if="errorForgotPassword === false" class="alert alert-success" style="margin: 10px 0">
                  <p>
                    An email has been sent. It contains a link you must click to reset your password. (check in your spam folder if you don't find it)
                  </p>
                </div>

                <div v-else-if="errorForgotPassword !== null" class="alert alert-danger" style="margin: 10px 0">
                  {{errorForgotPassword}}
                </div>

                <vue-ladda type="submit" :loading="submitForgot.loading" class="btn btn-info btn-block" :data-style="submitForgot.dataStyle">Reset password</vue-ladda>
              </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <strong><a href="https://www.idexlab.com" target="_blank"> IDEXLAB</a></strong><br/> {{year}} Copyright Idexlab
      </div>
    </div>
  </div>

</template>

<style>
</style>

<script>

  import VueLadda from 'vue-ladda'

  export default {
  components: {VueLadda},
  name: 'ForgotPassword',
  methods: {
    forgotPassword: function (event) {
      this.submitForgot.loading = true
      this.axios.post('/auth/forgotPassword', {
        email: this.email
      })
        .then((response) => {
          this.errorForgotPassword = false
          this.submitForgot.loading = false
        })
        .catch((error) => {
          if (error.response.status === 400) {
            if (error.response.data.code === 1) {
              this.errorForgotPassword = error.response.data.errors['email'][0]
            } else if (error.response.data.code === 2) {
              this.errorForgotPassword = error.response.data.message
            }
          }
          this.submitForgot.loading = false
        })
      event.preventDefault()
    }
  },
  mounted () {
  },
  data () {
    return {
      email: '',
      errorForgotPassword: null,
      submitForgot: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      year: new Date().getFullYear()
    }
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/ForgotPassword.vue